import { render, staticRenderFns } from "./TheHeadingNavigationBar.vue?vue&type=template&id=5c754be6&scoped=true&"
import script from "./TheHeadingNavigationBar.vue?vue&type=script&lang=js&"
export * from "./TheHeadingNavigationBar.vue?vue&type=script&lang=js&"
import style0 from "./TheHeadingNavigationBar.vue?vue&type=style&index=0&id=5c754be6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c754be6",
  null
  
)

export default component.exports